
import {useState} from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import {
        Stack, 
        TextField,
        Grid
} from '@mui/material';

export default function EscolherDatas() {
  const [inicio, setInicio] = useState(null);
  const [fim, setFim] = useState(null);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>

      <Grid container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center">
          <Grid item xs={2} md={4} lg={6} paddingBottom={1}>
            <DatePicker
              label="Início"
              value={inicio}
              onChange={(newValue) => {
                setInicio(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </Grid>
          
          <Grid item xs={2} md={4} lg={6} paddingBottom={1}>
            <DatePicker
                label="Fim"
                value={fim}
                onChange={(newValue) => {
                  setFim(newValue);
                }}
                renderInput={(params) => <TextField {...params} />}
              />
          </Grid>
      </Grid>
    </LocalizationProvider>
  );
}
